import CommonFunctions from "./CommonFunctions";

export interface RecipientListWindowOptions {
    title: string;
    url: string;
    data?: Record<string, unknown>;
    /** POST is form encoded: a recipient selection runs past the URL length limit. */
    method?: "GET" | "POST";
}

/**
 * The recipient list of a serial mail, shared by the newsletter detail page and the grid. The rows
 * come rendered from the server (Views/Shared/RecipientList.cshtml); this shows and filters them.
 */
export default class RecipientListWindow {

    /** Entry point for a grid client template, which can only call a global with primitives. */
    static openFromGrid(url: string, newsletterArchivId: number): void {
        RecipientListWindow.open({
            title: TextResources.Views_Recipients,
            url,
            method: "GET",
            data: { newsletterArchivId }
        });
    }

    static open(options: RecipientListWindowOptions): void {
        const windowEl = $("<div class='recipientListWindow'></div>").appendTo("body");
        const kendoWindow = windowEl.kendoWindow({
            title: options.title,
            modal: true,
            width: 720,
            maxHeight: Math.max(320, $(window).height() - 120),
            deactivate() { kendoWindow.destroy(); }
        }).data("kendoWindow");

        kendoWindow.center().open();
        CommonFunctions.isLoading(windowEl);

        $.ajax({
            url: options.url,
            type: options.method ?? "POST",
            data: options.data
        }).done((html: string) => {
            CommonFunctions.isLoadeded(windowEl);
            windowEl.html(html);
            RecipientListWindow.wireUp(windowEl, kendoWindow, options.title);
            kendoWindow.center();
        }).fail(() => {
            CommonFunctions.isLoadeded(windowEl);
            windowEl.html(`<div class='recipientListEmpty'>${kendo.htmlEncode(TextResources.Views_Fehler)}</div>`);
        });
    }

    private static wireUp(windowEl: JQuery, kendoWindow: kendo.ui.Window, title: string): void {
        const rows = windowEl.find(".recipientListItem");
        const emptyEl = windowEl.find(".recipientListEmpty");
        const searchEl = windowEl.find(".recipientListSearch");
        searchEl.kendoTextBox({ placeholder: TextResources.Views_Suchen });

        // The count goes in the title; next to the search it reads as a stray number.
        const draw = (term: string) => {
            const needle = term.trim().toLowerCase();
            let visible = 0;
            rows.each((_, element) => {
                const haystack = ($(element).attr("data-search") ?? "");
                const matches = needle.length === 0 || haystack.indexOf(needle) >= 0;
                $(element).toggle(matches);
                if (matches) {
                    visible++;
                }
            });

            emptyEl.toggle(visible === 0);
            kendoWindow.title(visible === rows.length
                ? `${title} (${rows.length})`
                : `${title} (${visible} / ${rows.length})`);
        };

        searchEl.on("input", () => draw(searchEl.val() as string));
        draw("");
        searchEl.trigger("focus");
    }
}
